import { defineStore } from "pinia";
import { ref, reactive } from "vue";

function createClausulasConfirmacion() {
  return [
    {
      clausula_confirmacion_id: 14,
      contenido: "Confirmo que los documentos son mercantiles y la información proporcionada es correcta.",
      confirmado: false,
    },
    {
      clausula_confirmacion_id: 15,
      contenido: "Acepto los Términos y condiciones.",
      confirmado: false,
    },
    {
      clausula_confirmacion_id: 16,
      contenido:
        "Declaro, bajo protesta de decir la verdad que las páginas corresponden a la totalidad de las páginas que conforman el documento COMPLETO.",
      confirmado: false,
    },
    {
      clausula_confirmacion_id: 17,
      contenido:
        "Declaro, bajo protesta de decir la verdad que el PDF o Archivo que enviaré, corresponde al documento original que presentaré para cotejo de forma física en las oficinas que me sean indicadas.",
      confirmado: false,
    },
  ];
}

function createDomicilio() {
  return {
    delegacion_municipio: "",
    entidad: "",
    pais: "México",
  };
}

function getDefaultState() {
  return {
    id: null,
    id_estatus: null,
    id_prioridad: 2,
    id_cotizaciones: null,
    id_clientes: null,
    id_comparecientes: null,
    pago_complementario: null,
    id_cotizaciones_pago_complementario: null,
    envio_domicilio: 0,
    id_comparecientes_representante: null,

    currentComponentValues: {
      Solicitantes: false,
      DomicilioEntregaOriginales: false,
      Documentos: false,
      Cotizacion: false,
      Terminado: false,
    },

    solicitantes: [],
    telefono: {},

    envio_domicilio_bool: false,

    documentos: [],

    costo_total: 0,

    cotizacion: {},
    referencia: "",
    clausulas_confirmacion: createClausulasConfirmacion(),
    id_domicilio_entrega_originales: null,
    domicilio_entrega_originales: createDomicilio(),
  };
}

export const useCotejoStore = defineStore(
  "cotejo-store",
  () => {
    const currentComponentBody = ref("Solicitantes");

    const cotejo = reactive(getDefaultState());

    const comparecientes = ref([]);

    function initCotejoStore() {
      currentComponentBody.value = "Solicitantes";
      Object.assign(cotejo, getDefaultState());
      comparecientes.value = [];
    }

    return {
      currentComponentBody,
      cotejo,
      comparecientes,
      initCotejoStore,
    };
  },
  {
    persist: true,
  },
);
